// extracted by mini-css-extract-plugin
export var desktop = "A8OTg5DOUSo2zHqM8KA3";
export var dialog = "j25urekwx5jre4PXkv8x";
export var focusShift = "OHKD7MFhD6hK5AI_TjOA";
export var mobile = "N9gJVCj1UUUHmai0KAHs";